import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './PillDetailUser.module.css';

// 컴포넌트
import HeadSub from '../../../../../components/comm/HeadSub';
import SwitchBox from '../../../../../components/box/SwitchBox';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import ConfirmBox from '../../../../../components/box/ConfirmBox';
import Modal from '../../../../../components/comm/Modal';

// 아이콘 및 이미지
import day_morning from '../../../../../images/common/i_day_morning_02.svg';
import day_lunch from '../../../../../images/common/i_day_lunch_02.svg';
import day_night from '../../../../../images/common/i_day_night_02.svg';

// 라이브러리
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import { getPillAlarmTime, toPillTm } from '../../../../../constants/pillEraTime';
import PillDetailInformBox from '../../../../../components/box/PillDetailInformBox';

/**
 * 복약 정보 업데이트 API (알림 상태, 시간 등)
 * @param {object} updateData - 업데이트할 데이터
 */
const updateMedicationRecord = async (updateData) => {
    const url = "/homecare/tkmdcn/saveAlarmUserTakingMedicineInfo";
    const jToken = localStorage.getItem('jToken');
    const loginUser = JSON.parse(sessionStorage.getItem('loginUser') || '{}');

    const reqBody = {
        usrInfoId: loginUser.usrInfoId,
        usrTkmedicnInfoId: updateData.usrTkmedicnInfoId,
        ...(updateData.alrmAt !== undefined && { alrmAt: updateData.alrmAt }),
        ...(updateData.reAlrmAt !== undefined && { reAlrmAt: updateData.reAlrmAt }),
        ...(updateData.alrmSetupTm !== undefined && { alrmSetupTm: updateData.alrmSetupTm })
    };

    const requestOption = {
        headers: {
            "Authorization": `Bearer ${jToken}`,
        },
    };

    try {
        const res = await axiosApi.post(url, reqBody, requestOption);

        if (res.data.resultCode === CODE.RCV_SUCCESS) {
            console.log("업데이트 성공:", res.data.result);
            return true;
        } else {
            console.warn("업데이트 실패:", res.data.resultMessage);
            return false;
        }

    } catch (err) {
        console.error("업데이트 API 호출 중 오류", err);
        return false;
    }
};

/**
 * 복약 정보 삭제 API
 * @param {number} usrTkmedicnInfoId - 삭제할 복약 정보 ID
 */
const deleteMedicationRecord = async (usrTkmedicnInfoId) => {
    const url = "/homecare/tkmdcn/saveNotUseTakingMedicineInfo";
    const jToken = localStorage.getItem('jToken');
    const loginUser = JSON.parse(sessionStorage.getItem('loginUser') || '{}');

    const reqBody = {
        usrInfoId: loginUser.usrInfoId,
        usrTkmedicnInfoId: usrTkmedicnInfoId
    };

    const requestOption = {
        headers: {
            "Authorization": `Bearer ${jToken}`,
        },
    };

    try {
        const res = await axiosApi.post(url, reqBody, requestOption);

        if (res.data.resultCode === CODE.RCV_SUCCESS) {
            console.log("삭제 성공");
            return true;
        } else {
            console.warn("삭제 실패:", res.data.resultMessage);
            return false;
        }

    } catch (err) {
        console.error("삭제 API 호출 중 오류", err);
        return false;
    }
};


const PillDetailUser = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const getInitialState = () => {
        const item = location?.state || {};

        const initialToggle = item.alrmAt === '1';

        const initialTime = getPillAlarmTime(item);

        return { item, initialToggle, initialTime };
    };

    const { item, initialToggle, initialTime, initialRepeatOn } = useMemo(getInitialState, [location?.state]);
    const [repeatOn, setRepeatOn] = useState(item?.reAlrmAt === '1');
    // console.log(JSON.stringify(item, null, 2));
    const [isOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [toggle, setToggle] = useState(initialToggle);
    const [alarmTime, setAlarmTime] = useState(initialTime);
    const [tkmdcnCd, setTkmdcnCd] = useState('');
    const [isModifyOpen, setIsModifyOpen] = useState('');  // 수정 확인 팝업 추가 
    const [isAlarmModalOpen, setIsAlarmModalOpen] = useState(false); // 알림 끄기 모달창

    useEffect(() => {
        setOpen(false);
    }, []);

    //수정 확인 팝업 닫기
    const handleConfirmModify = (e) => {
        if(e) {
            navigate('/PillModify', { state: item });
        }else {
            setIsModifyOpen(false);
        }
    }

    const handleConfirmDelete = async (e) => {
        if (e) {
            const success = await deleteMedicationRecord(item.usrTkmedicnInfoId);
            if (success) {
                navigate(-1);
            } else {
                alert("삭제에 실패했습니다. 다시 시도해주세요.");
                setIsOpen(false);
            }
        } else {
            setIsOpen(false);
        }
    }

    function onDismiss() {
        setOpen(false);
        setOpen2(false);
    }

    const parsedPillList = useMemo(() => {
        if (typeof item?.tkmdcnCn === 'string') {
            return item.tkmdcnCn.split('@,@');
        }
        return [];
    }, [item?.tkmdcnCn]);

    const parsedPillCdList = useMemo(() => {
        if (typeof item?.tkmdcnCdCn === 'string') {
            return item.tkmdcnCdCn.split('@,@');
        }
        return [];
    }, [item?.tkmdcnCdCn]);

    const formatTime = (hour, minute) => {
        const ampm = hour < 12 ? "오전" : "오후";
        const hr = hour % 12 === 0 ? 12 : hour % 12;
        const min = String(minute).padStart(2, "0");
        return `${ampm} ${hr}:${min}`;
    };

    const deleteNotification = () => {
        setIsOpen(true);
    };

    // const toggleNotification = async () => {
    //     const newToggle = !toggle;
    //     const newStatus = newToggle ? '1' : '0';

    //     setToggle(newToggle);

    //     if (!newToggle && repeatOn) {
    //         await updateMedicationRecord({
    //             usrTkmedicnInfoId: item.usrTkmedicnInfoId,
    //             reAlrmAt: '0'
    //         });
    //         setRepeatOn(false);
    //     }

    //     const success = await updateMedicationRecord({
    //         usrTkmedicnInfoId: item.usrTkmedicnInfoId,
    //         alrmAt: newStatus
    //     });

    //     if (!success) {
    //         setToggle(!newToggle);
    //         alert("알림 설정 변경에 실패했습니다.");
    //     }
    // };

    const toggleNotification = async () => {
        const newToggle = !toggle;

        if (!newToggle) {
            // 알림 끄기 → 모달 표시
            setIsAlarmModalOpen(true);
            return;
        }

        // 알림 켜기 → 바로 처리
        const success = await updateMedicationRecord({
            usrTkmedicnInfoId: item.usrTkmedicnInfoId,
            alrmAt: '1',
            alrmSetupTm: toPillTm(alarmTime)
        });

        if (success) {
            setToggle(true);
        } else {
            alert("알림 설정 변경에 실패했습니다.");
        }
    };

    // 모달 취소
    const cancelTurnOffAlarm = () => {
        setIsAlarmModalOpen(false);
    };

    // 모달 확인 — 알림 끄기 실행
    const confirmTurnOffAlarm = async () => {
        if (repeatOn) {
            await updateMedicationRecord({
                usrTkmedicnInfoId: item.usrTkmedicnInfoId,
                reAlrmAt: '0'
            });
            setRepeatOn(false);
        }

        const success = await updateMedicationRecord({
            usrTkmedicnInfoId: item.usrTkmedicnInfoId,
            alrmAt: '0'
        });

        if (success) {
            setToggle(false);
        } else {
            alert("알림 끄기에 실패했습니다.");
        }

        setIsAlarmModalOpen(false);
    };


    const updateAlarmTime = async (newTime) => {
        const oldTime = alarmTime;

        setAlarmTime(newTime);

        const formattedTime =
            String(newTime.hour).padStart(2, '0') +
            String(newTime.minute).padStart(2, '0') +
            '00'; // HHMMSS

        const success = await updateMedicationRecord({
            usrTkmedicnInfoId: item.usrTkmedicnInfoId,
            alrmSetupTm: formattedTime
        });

        if (!success) {
            setAlarmTime(oldTime);
            alert("알림 시간 변경에 실패했습니다.");
        }
    };

    // 아침/점심/저녁 아이콘 반환
    const getImgSrc = () => {
        const selectedTime = item?.tkmdcnEraNm;
        if (selectedTime === '아침') return day_morning;
        if (selectedTime === '점심') return day_lunch;
        if (selectedTime === '저녁') return day_night;
        return day_morning; // 기본값 (또는 기타 아이콘)
    };

        // 오늘 날짜가 복약 기간에 포함되는지 확인
    const isTodayInPeriod = useMemo(() => {
        if (!item?.tkmdcnPdCn) return false;
        
        try {
            // "25.11.14 ~ 25.11.20 (총 7일)" 형식에서 날짜 추출
            const dateMatch = item.tkmdcnPdCn.match(/(\d{2}\.\d{2}\.\d{2})\s*~\s*(\d{2}\.\d{2}\.\d{2})/);
            
            if (!dateMatch) return false;
            
            const [, startDateStr, endDateStr] = dateMatch;
            
            // YY.MM.DD 형식을 Date 객체로 변환
            const parseDate = (dateStr) => {
                const [year, month, day] = dateStr.split('.').map(Number);
                return new Date(2000 + year, month - 1, day);
            };
            
            const startDate = parseDate(startDateStr);
            const endDate = parseDate(endDateStr);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            return today >= startDate && today <= endDate;
        } catch (error) {
            console.error('날짜 파싱 오류:', error);
            return false;
        }
    }, [item?.tkmdcnPdCn]);


    //다시 알람 설정 추가
    const toggleRepeatSwitch = async (status) => {
        const success = await updateMedicationRecord({
            usrTkmedicnInfoId: item.usrTkmedicnInfoId,
            reAlrmAt: status ? '1' : '0'
        });

        if (success) {
            setRepeatOn(status);
        } else {
            alert("다시 알림 설정에 실패했습니다.");
        }
    };

    return (
        <>
            <HeadSub title="복약 기록 상세" />

            <div className={style['top-control-box']}>
                {item?.tkmdcnGrpCd === 'ETC' && isTodayInPeriod &&
                    <button className={style['top-control-btn']} onClick={() => {
                        // navigate('/PillModify', { state: item });
                        setIsModifyOpen(true);
                    }}>
                        <span>수정</span>
                    </button>
                }
                <button className={style['top-control-btn']} onClick={deleteNotification}>
                    <span>삭제</span>
                </button>
            </div>

            <div className="container" data-padding="none">
                <div className={style["pill-detail-box"]}>
                    <div className={style["innerbox"]}>
                        <div className={style["period-box"]}>
                            <span>
                                <img src={getImgSrc()} alt={item?.tkmdcnEraNm} />
                                {item?.tkmdcnEraNm} {/* 아침/점심/저녁 */}
                            </span>
                            {/* tkmdcnGrpCd */}

                            {/* 식후즉시 등 */}
                            {item?.tkmdcnGrpCd !== 'G20' && <span>{item?.tkmdcnMthCn}</span>}
                        </div>
                        <div className={style["alarm-box"]}>
                            <strong
                                className={!toggle ? style['no-alarm'] : ''}
                                onClick={() => toggle && setOpen(true)}

                            >
                                {formatTime(alarmTime.hour, alarmTime.minute)}
                            </strong>

                            {item?.tkmdcnGrpCd !== 'G20' &&
                                <div className="" data-swich-size="sm">
                                    <SwitchBox
                                        toggles={toggle}
                                        status={toggleNotification}
                                    />
                                </div>                                
                            }
                        </div>

                        {/* 다시 알림 설정 추가 2026.03.18 */}
                        <div className={style['infom-wrap']}>
                            {toggle && (  
                                <div className="animation-1">
                                    <div className={style['infom-box']}>
                                        <p className={style['tit']}>다시 알림 설정</p>
                                        <SwitchBox
                                            size="small"
                                            status={status => toggleRepeatSwitch(status)} 
                                            toggles={repeatOn}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className={style["infom-wrap"]}>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>처방 정보</p>
                                <p>
                                    <span>{item?.cnncHsptlNm || '처방 외 복용'}</span>
                                    {item?.cnncDeptNm && <span> / {item?.cnncDeptNm}</span>}
                                </p>
                            </div>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>복약 기간</p>
                                <span>{item?.tkmdcnPdCn}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={style["pill-infom-box"]}>
                    <div className="inner-wrap" data-pad="normal">
                        <div className={style['check-point-box']}>
                            <strong>꼭 확인해주세요!</strong>
                            <ul>
                                <li>알림이 적용되기까지 최대 30분 정도 걸릴 수 있습니다.</li>
                            </ul>
                        </div>
                        <div className={style["user-pill-list-box"]}>
                            <ul>
                                {/* parsedPillList가 비어있지 않을 때만 map 실행 */}
                                {parsedPillList.length > 0 ? (
                                    parsedPillList.map((pill, index) => (
                                        <li key={index} onClick={() => {
                                            if (item?.tkmdcnGrpCd !== "ETC") { // 처방외는 정보제공안함.
                                                setTkmdcnCd(parsedPillCdList[index]);
                                                setOpen2(true);
                                            }
                                        }}>
                                            <span>{pill}</span>
                                        </li>
                                    ))
                                ) : (
                                    <li>
                                        <span>등록된 약 정보가 없습니다.</span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>

                <BottomSheet
                    open={open}
                    scrollLocking={false}
                    expandOnContentDrag={false}
                    onDismiss={onDismiss}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking={true}
                >
                    <CustomTimePicker
                        onClose={onDismiss}
                        onConfirm={async (time) => {
                            const hh = String(time.hour).padStart(2, '0');
                            const mm = String(time.minute).padStart(2, '0');
                            const formatted = `${hh}${mm}00`;
                            await updateMedicationRecord({
                                usrTkmedicnInfoId: item.usrTkmedicnInfoId,
                                alrmSetupTm: formatted
                            });

                            // 화면상 표시시간 갱신
                            setAlarmTime(time);

                            navigate('.', {
                                replace: true,
                                state: {
                                    ...item,
                                    alrmSetupTm: formatted
                                }
                            });

                            onDismiss();
                        }}
                        titleTxt="알림 시간 선택"
                        initialTime={alarmTime}
                    />
                </BottomSheet>

                <BottomSheet

                    scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                    expandOnContentDrag={false} // 내용 드래그로 확장 방지
                    open={open2}
                    onDismiss={onDismiss}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking={true}
                >
                    <PillDetailInformBox
                        key={`${item?.cnncHsptlCd}_${tkmdcnCd}`} // 고유값 지정
                        hsptlCd={item?.cnncHsptlCd}
                        mdctnNo={tkmdcnCd}
                        onClose={onDismiss} />
                </BottomSheet>

                <ConfirmBox
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    onCloseCallback={handleConfirmDelete}
                    message={
                        <>
                            삭제하시겠어요? <br />
                            삭제 시 기존 기록 내역은 모두 사라집니다.
                        </>
                    }
                    leftBtnTxt={'아니오'}
                    rightBtnTxt={'네'}
                />


                <ConfirmBox
                    isOpen={isModifyOpen}
                    setIsOpen={setIsModifyOpen}
                    onCloseCallback={handleConfirmModify}
                    message={'수정하시겠어요?'}
                    leftBtnTxt={'아니오'}
                    rightBtnTxt={'네'}
                >
                    <span className={style['modify-pop-sub-txt']}>수정 시 수정 내용은 수정일 이후로만 적용되며 <br/>
                            기존 기록 내역에는 적용되지 않습니다.</span>
                </ConfirmBox>


                <Modal isOpen={isAlarmModalOpen} setIsOpen={setIsAlarmModalOpen}>
                    <div className="modal-box" data-type="a">
                        <div className="modal-top-box">
                            <div className="title-box">
                                <p>알림을 끄시겠어요?</p>
                            </div>
                        </div>
                        <div className="modal-bottom-box">
                            <div className="btn-layout">
                                <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelTurnOffAlarm}>
                                    <span>취소</span>
                                </button>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={confirmTurnOffAlarm}>
                                    <span>끄기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>   
                
            </div>
        </>
    );
};

export default PillDetailUser;
